import 'HeadJS/modules/hns';
import 'HeadJS/modules/hubspot.require';
import 'HeadJS/modules/hubspot-define-lazy-by-default';
import './set-hubspot-bender-global';
import Raven from 'raven-js';
import { enableRejectionTracking } from 'hs-promise-rejection-tracking';
enableRejectionTracking();

/*
  The back/forward cache in browsers caches the state of the page
  and reuses that state when using the back/forward buttons in the browser.
  This can cause a leak of data after a user logs out. For now we are
  just forcing the page to reload as if it was not cached.
*/
window.addEventListener('pageshow', event => {
  if (event.persisted) {
    window.location.reload();
  }
});

// We use `defineProperty` to create the globals so we can have hook into tracking usage when we choose to deprecate

// backwards compatibility for libraries/apps that assume window.Raven.
Object.defineProperty(window, 'Raven', {
  get() {
    return Raven;
  }
});
Object.defineProperty(window, 'enviro', {
  get() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const enviroModule = require('enviro');
    return enviroModule.default || enviroModule;
  }
});